import React from 'react'

export type StaticImageData = any

export interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string | StaticImageData
  alt: string
  width?: number | string
  height?: number | string
  fill?: boolean
  priority?: boolean
  quality?: number
  placeholder?: string
  unoptimized?: boolean
}

export default function Image({
  src,
  alt,
  width,
  height,
  fill,
  priority,
  quality,
  placeholder,
  unoptimized,
  style,
  ...props
}: ImageProps) {
  const fillStyle: React.CSSProperties = fill
    ? {
        position: 'absolute',
        height: '100%',
        width: '100%',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        objectFit: 'cover',
      }
    : {}

  const combinedStyle = { ...fillStyle, ...style }

  return (
    <img
      src={typeof src === 'string' ? src : (src as any)?.src || ''}
      alt={alt}
      width={width}
      height={height}
      style={combinedStyle}
      {...props}
    />
  )
}
